import React, { FC, useEffect, useRef, useState } from 'react';
import cls from './MultiSelect.module.css';
import classNames from 'classnames';
import { Option } from './Option/Option';

export const MultiSelect = ({
    selected,
    options,
    placeholder,
    status,
    deleteHandle,
    onChange,
    onClose,
    title,
    isRequired,
    isDisabled = false,
    error = null,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [optionFilter, setOptionFilter] = useState('');
    const rootRef = useRef(null);
    const [resultFilter, setResultFilter] = useState([]);

    const valuesList = selected.map((i) => i.value);

    useEffect(() => {
        const handleClick = (event) => {
            const { target } = event;
            if (target instanceof Node && !rootRef.current?.contains(target)) {
                isOpen && onClose?.();
                setIsOpen(false);
                setOptionFilter('');
            }
        };
        window.addEventListener('click', handleClick);

        return () => {
            window.removeEventListener('click', handleClick);
        };
    }, [isOpen, onClose]);

    useEffect(() => {
        setResultFilter(options);
    }, [options]);

    const handleOptionClick = (value) => {
        setIsOpen(false);
        onChange(value);
    };
    const handlePlaceHolderClick = () => {
        if (!isDisabled) {
            if (isOpen) {
                setOptionFilter('');
            }
            setIsOpen(!isOpen);
        }
    };

    const handleOptionFilter = (event) => {
        setOptionFilter(event.target.value);
    };

    useEffect(() => {
        const result = options.filter(({ title, _ }) =>
            title.toLowerCase().includes(optionFilter.toLowerCase())
        );

        if (!result.length) {
            setResultFilter([
                {
                    title: i18next.t('MultiSelect.useEffect.setResultFilter.title'),
                    value: 'null',
                    account: { is_archive: false },
                    isDisabled: true,
                },
            ]);
        } else {
            setResultFilter(result);
        }
    }, [optionFilter]);
    return (
        <div className={classNames(cls.formBlockContent)}>
            {title && (
                <label className={classNames(cls.modalLabelSelect, { [cls.disabled]: isDisabled })}>
                    {title}
                    {isRequired && <span>*</span>}
                </label>
            )}
            <div
                onClick={handlePlaceHolderClick}
                className={classNames(cls.selectWrapper, { [cls.disabled]: isDisabled })}
                ref={rootRef}
                data-is-active={isOpen}
            >
                <div className={classNames(cls.arrow)}>
                    <svg
                        width="9"
                        height="6"
                        viewBox="0 0 9 6"
                        fill="currentColor"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path d="M4.5 5.5L9 0.5H0L4.5 5.5Z" fill="currentColor" fillOpacity="0.6" />
                    </svg>
                </div>
                <div className={classNames(cls.selectedWrapper)}>
                    {selected.length === 0 ? (
                        <div className={classNames(cls.selected, { [cls.disabled]: isDisabled })}>
                            <span className={classNames(cls.selectedSpan)}>
                                {i18next.t('MultiSelect.return.selectedWrapper.selectedSpan')}
                            </span>
                        </div>
                    ) : (
                        selected.map((option) => (
                            <div
                                key={option.value}
                                className={classNames(cls.selected, { [cls.disabled]: isDisabled })}
                            >
                                <span
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        deleteHandle(option.value);
                                    }}
                                    className={classNames(cls.delete)}
                                >
                                    ×
                                </span>
                                <span className={classNames(cls.selectedSpan)}>{option.title}</span>
                            </div>
                        ))
                    )}
                </div>

                {isOpen && (
                    <ul className={classNames(cls.option)}>
                        <div
                            className={classNames(cls.filterInput)}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <input
                                className={classNames(cls.input)}
                                onChange={(event) => handleOptionFilter(event)}
                            />
                        </div>
                        {resultFilter.map((option) => (
                            <Option
                                isActive={valuesList.includes(option.value)}
                                key={option.value}
                                option={option}
                                onClick={handleOptionClick}
                                setIsOpen={setIsOpen}
                            />
                        ))}
                    </ul>
                )}
            </div>
            {error && <span className={classNames(cls.errorMessage)}>{error}</span>}
        </div>
    );
};
